module.exports = __webpack_public_path__ + "static/media/large.fbd883cc.png";